import { Circle, Diamond, Square, type LucideIcon } from "lucide-react";

// The Green / Yellow / Red self-assessment vocabulary.
// Status is NEVER color alone — always paired with a shape (Circle / Diamond /
// Square) and a label, for colorblind accessibility and emotional neutrality.
export type StatusKey = "green" | "yellow" | "red";

export const STATUS_ORDER: StatusKey[] = ["green", "yellow", "red"];

export const STATUS_SHAPES: Record<StatusKey, LucideIcon> = {
  green: Circle,
  yellow: Diamond,
  red: Square,
};

// Neutral, honest labels — choosing Red is bravery, not failure.
export const STATUS_DEFAULT_LABELS: Record<StatusKey, string> = {
  green: "I'm doing well",
  yellow: "Something feels off",
  red: "I need help",
};

export const STATUS_SHORT_LABELS: Record<StatusKey, string> = {
  green: "Green",
  yellow: "Yellow",
  red: "Red",
};
